import { Lesson } from "@jelly/lesson";

import principle01 from "./layouts/principle-01/principle";
import principle02 from "./layouts/principle-02/principle";
import principle03 from "./layouts/principle-03/principle";
import task01 from "./layouts/task-01/task";
import task02 from "./layouts/task-02/task";

const lesson: Lesson = {
  id: "d748302c-ec10-4952-8bce-f964e2d37718",
  publicId: "23",
  name: "Panning techniques Object-based audio",
  difficulty: 3,
  contentTypes: { audio: true, interactive: true, video: false },
  body: [principle01, principle02, principle03, task01, task02],
};

export default lesson;
